import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { tenantDevHostInterceptor } from './tenant-dev-host.interceptor';
import { RestaurantConfigService } from './services/restaurant-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([tenantDevHostInterceptor])),
    provideAppInitializer(() => {
      const config = inject(RestaurantConfigService);
      return config.load();
    }),
  ],
};
